import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import entries from 'lodash/entries';
import Category from './Category';

class PopoverBody extends PureComponent {
    constructor(props) {
        super(props);

        const expandedCategory = entries(props.categories).length === 1
            ? entries(props.categories)[0][0]
            : null;

        this.state = { expandedCategory };
    }

    // setting current expanded category
    toggleExpanded = (category) => {
        this.setState(({ expandedCategory }) => ({
            expandedCategory: expandedCategory === category ? null : category
        }));
    }

    render() {
        const { categories, dispatch } = this.props;
        const { expandedCategory } = this.state;

        return (
            <div className="cmn-filter__popoverBody">
                {entries(categories).map(([categoryName, category]) =>
                    <Category
                        key={categoryName}
                        type={categoryName}
                        toggleExpanded={this.toggleExpanded}
                        expanded={expandedCategory === categoryName}
                        title={category.title}
                        options={category.options}
                        dispatch={dispatch}
                        isHidden={category.isHidden}
                    />
                )}
            </div>
        );
    }
}

PopoverBody.propTypes = {
    categories: PropTypes.shape({}),
    dispatch: PropTypes.func.isRequired
};

export default PopoverBody;



// WEBPACK FOOTER //
// ./~/rp-react-common/Filter/components/PopoverBody.jsx